<template>
  <div class="condicao-pagamento">
    <CTabs variant="tabs" class="nav-tabs-boxed">
      <CTab title="Operações"><Operacoes /></CTab>
      <CTab title="Cobranças"><Cobrancas /></CTab>
      <CTab title="Planos de Pagamento"><PlanosPagamento /></CTab>
      <CTab title="Operação x Cobrança"><CobrancaOperacao /></CTab>
      <CTab title="Operação x Plano"><OperacaoPlano /></CTab>
<CTab title="Operação x Cliente"><OperacaoCliente /></CTab>
      <CTab title="Cobrança x Grupo"><GruposCobranca /></CTab>
      <CTab title="Cobrança x Plano"><PlanosCobranca /></CTab>
      <CTab title="Cobrança x Filial"><CobrancaFilial /></CTab>
      <CTab title="Cobrança x Cliente"><CobrancaCliente /></CTab>
      <CTab title="Restrição Plano"><PlanosRestricao /></CTab>
      <CTab title="Plano x Filial"><PlanoFilial /></CTab>
      <CTab title="Plano x Cliente"><PlanoCliente /></CTab>
    </CTabs>
  </div>
</template>

<script>
import PlanosPagamento from './Condicao/PlanosPagamento';
import Cobrancas from './Condicao/Cobrancas';
import Operacoes from './Condicao/Operacoes';
import GruposCobranca from './Condicao/GruposCobranca';
import PlanosCobranca from './Condicao/PlanosCobranca';
import CobrancaOperacao from './Condicao/CobrancaOperacao';
import PlanosRestricao from './Condicao/PlanosRestricao';
import CobrancaFilial from './Condicao/CobrancaFilial';
import CobrancaCliente from './Condicao/CobrancaCliente';
import OperacaoPlano from './Condicao/OperacaoPlano';
import OperacaoCliente from './Condicao/OperacaoCliente';
import PlanoFilial from './Condicao/PlanoFilial';
import PlanoCliente from './Condicao/PlanoCliente';
import { loadDescs } from '@/helpers/utils';

export default {
  name: 'condicao-pagamento',
  components: {
    PlanosPagamento,
    Cobrancas,
    Operacoes,
    GruposCobranca,
    PlanosCobranca,
    CobrancaOperacao,
    PlanosRestricao,
    CobrancaFilial,
    CobrancaCliente,
    OperacaoPlano,
    OperacaoCliente,
    PlanoFilial,
    PlanoCliente,
  },

  data() {
    return {
      descSingular: '',
      descPlural: '',
    };
  },

  beforeMount() {
    const { descSingular, descPlural } = loadDescs('ADMIN_CONDICAO_PAGAMENTO');
    this.descSingular = descSingular;
    this.descPlural = descPlural;
  },
};
</script>

<style scoped>
.condicao-pagamento ::v-deep .nav-tabs {
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.condicao-pagamento ::v-deep .nav-tabs::-webkit-scrollbar {
  height: 4px;
}

.condicao-pagamento ::v-deep .nav-tabs::-webkit-scrollbar-thumb {
  background: #d8dbe0;
  border-radius: 2px;
}

.condicao-pagamento ::v-deep .nav-item {
  flex-shrink: 0;
}
</style>
